import React from 'react';
import './index.css';

function AnimatedCheckMark (props) {
	return (
		<div className="icon--order-success">
			<svg xmlns="http://www.w3.org/2000/svg" width={154} height={154} {...props}>
				<g fill="none" stroke="#5dae5c" strokeWidth={2}>
					<circle
						className="border-circle"
						cx={77}
						cy={77}
						r={72}
					/>
					<circle
						className="plain-circle"
						cx={77}
						cy={77}
						r={72}
					/>
					<path
						className="check-mark"
						d="m43.5 77.8 20.2 20.1 48.5-48.5"
					/>
				</g>
			</svg>
		</div>
	)
}

export default AnimatedCheckMark;
